module.exports = __webpack_public_path__ + "img/landlord-home-insurance.1bb41587.svg";